import { defineRecipe } from '@chakra-ui/react';

export const iconRecipe = defineRecipe({
  base: {
    display: 'inline-block',
    lineHeight: '1em',
    flexShrink: '0',
    color: 'currentcolor',
    verticalAlign: '-.125em',
  },
});
